import { Component, Input, OnInit } from '@angular/core';

import { HisUiService, HisAuthService } from 'hisng';
import { PATENT_STATE_REGISTERED, PATENT_STATE_PUBLISHED, PATENT_STATE_GRANTED,
    PATEN_REGISTRATIONTYPE_COUNTRY_SPECIFIC } from 'app/fs/res/patent/model/constants';
import { Patent } from 'app/fs/res/patent/model/patent/patent';

@Component( {
    selector: 'res-patent-view-vcard',
    templateUrl: './patent-view-vcard.component.html',
    preserveWhitespaces: false
} )
export class PatentViewVCardComponent implements OnInit {
    @Input() patent: Patent;

    showAllInventors = true;
    call = 0;

    public dateFormat: string;

    constructor(
        public auth: HisAuthService,
        private hisUiService: HisUiService
    ) { }

    ngOnInit() {
        this.dateFormat = this.hisUiService.translate( 'common.dateFormat' );
        console.log( this.patent );
    }

    public isGranted(): boolean {
        if ( this.patent ) {
            if ( this.patent.status ) {
                if ( this.patent.status.hiskeyId === PATENT_STATE_GRANTED ) {
                    return true;
                }
            }
        }
        return false;
    }

    public isRegistered(): boolean {
        if ( this.patent ) {
            if ( this.patent.status ) {
                if ( this.patent.status.hiskeyId === PATENT_STATE_REGISTERED ) {
                    return true;
                }
            }
        }
        return false;
    }

    public isPublished(): boolean {
        if ( this.patent ) {
            if ( this.patent.status ) {
                if ( this.patent.status.hiskeyId === PATENT_STATE_PUBLISHED ) {
                    return true;
                }
            }
        }
        return false;
    }

    isPriority(): boolean {
        return this.patent.priorityPatent == null ? true : false;
    }

    public isCountrySpecific(): boolean {
        if ( this.patent ) {
            if ( this.patent.registrationType ) {
                if ( this.patent.registrationType.hiskeyId === PATEN_REGISTRATIONTYPE_COUNTRY_SPECIFIC ) {
                    return true;
                }
            }
        }
        return false;
    }
}
